import React, { useEffect, useState } from "react";
import { Switch, Route, useHistory, Redirect } from "react-router-dom";
import { Tabs } from "components/common_components/Tabs";
import Header from "components/common_components/Header";
import Groups from "./Groups";
import Permissions from "./Permissions";

const options = [
    { index: 0, label: "Groups", path: "/settings/groups-permissions/groups", icon: "groups" },
    { index: 1, label: "Permissions", path: "/settings/groups-permissions/permissions", icon: "permissions" },
];

function GroupsPermissions(props) {
    const history = useHistory();
    const [selectedOption, setSelectedOption] = useState(options[0]);

    useEffect(() => {
        const newSelectedOption = options.find((o) => history.location.pathname.startsWith(o.path));
        if (newSelectedOption) {
            setSelectedOption(newSelectedOption);
        }
    }, [history.location.pathname]);

    function handleChange(_, newIndex) {
        history.push(options.find((o) => o.index === newIndex).path);
    }

    const renderTabLabel = (label) => {
        return label;
    };
    return (
        <>
            <Header title="Groups / Permissions" />
            <Tabs options={options} selectedOption={selectedOption} onChange={handleChange} renderTabLabel={renderTabLabel}>
                <Switch>
                    <Redirect exact from="/settings/groups-permissions" to="/settings/groups-permissions/groups" />
                    <Route exact path="/settings/groups-permissions/groups" component={Groups} />
                    <Route exact path="/settings/groups-permissions/permissions" component={Permissions} />
                </Switch>
            </Tabs>
        </>
    );
}

export default GroupsPermissions;
